// Copyright (c) StrangeBee 2024

import { Route as DashboardDetailsRoute } from './Details';
import { Route as DashboardHomeRoute } from './List';

export const Routes = [DashboardDetailsRoute, DashboardHomeRoute];
